// src/components/BackgroundSmileys.jsx
import React, { useMemo } from 'react';
import './BackgroundSmileys.css';

/**
 * Genereert een fixed achtergrondlaag met zwevende oranje smileys 😊.
 * - pointer-events: none → geen invloed op clicks/scroll
 * - z-index: 0 → achter je nav/content, vóór body–kleur
 */
export default function BackgroundSmileys() {
  const smileys = useMemo(
    () =>
      [...Array(25)].map((_, i) => ({
        id: i,
        size: 20 + Math.random() * 40,          // 20-60 px
        left: Math.random() * 100,              // willekeurige x-positie
        delay: Math.random() * 20,              // startvertraging
        duration: 30 + Math.random() * 20,      // 30-50 s per cyclus
        opacity: 0.2 + Math.random() * 0.4,     // 0.2-0.6 doorzichtig
      })),
    []
  );

  return (
    <div className="smiley-bg">
      {smileys.map(({ id, size, left, delay, duration, opacity }) => (
        <span
          key={id}
          className="smiley"
          style={{
            width: size,
            height: size,
            left: `${left}%`,
            animationDelay: `${delay}s`,
            animationDuration: `${duration}s`,
            opacity,
            fontSize: `${size}px`,
          }}
        >
          😊
        </span>
      ))}
    </div>
  );
}
